import { CompanyEntity } from "./CompanyEntity"

export interface CompanyDockageEntity {
    id: number | null,
    versionIdentifier: {
        version?: string
    },
    companyId: number | null,
    tier: number | null,
    hoursInTier: number | null,
    calculatedByHours: string | null,
    company: CompanyEntity | null,

    [key: string]: string | boolean | number | null | undefined | Object
}

export const EMPTY_COMPANY_DOCKAGE_ENTITY: CompanyDockageEntity = {
    id: 0,
    versionIdentifier: {},
    companyId: null,
    tier: null,
    hoursInTier: null,
    calculatedByHours: null,
    company: null,
}